var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.showDetail ? "open" : "",
        "go-panel-secondary go-panel-reference-detail",
      ],
    },
    [
      _c("div", { staticClass: "go-panel" }, [
        _c("div", { staticClass: "go-panel-header" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-icon",
              attrs: { type: "button" },
              on: { click: _vm.closeDetail },
            },
            [_c("i", { staticClass: "go-icon-20 go-icon-arrow-left" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "go-doc-title" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectDocTmp,
                    expression: "selectDocTmp",
                  },
                ],
                staticClass: "form-control",
                staticStyle: { width: "300px" },
                on: {
                  change: [
                    function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectDocTmp = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.selectOtherDoc,
                  ],
                },
              },
              _vm._l(_vm.lstReference, function (model, index) {
                return _c(
                  "option",
                  { key: index, domProps: { value: model.docId } },
                  [_c("p", [_vm._v(_vm._s(model.title))])]
                )
              }),
              0
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "go-panel-body", staticStyle: { width: "100%" } },
          [
            _c(
              "div",
              { staticClass: "go-view-wrap", staticStyle: { width: "100%" } },
              [
                _c(
                  "vue-custom-scrollbar",
                  {
                    ref: "scrollArea",
                    staticClass: "go-view-inner overflow-y-scroll",
                    attrs: { settings: _vm.scrollSettings },
                  },
                  [
                    _c("section", { attrs: { id: "detail-reference-doc" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "go-content-area container",
                          staticStyle: { overflow: "unset" },
                        },
                        [
                          _c("div", { staticClass: "ds-detail-wrap-v2" }, [
                            _c("div", { staticClass: "ds-detail-content" }, [
                              _c("div", { staticClass: "detail-body" }, [
                                _c(
                                  "section",
                                  { staticClass: "detail-main detail-article" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "section-header",
                                        staticStyle: {
                                          "margin-bottom": "1rem",
                                        },
                                      },
                                      [
                                        _c("h1", {
                                          staticClass: "title",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.selectedDoc.title
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content":
                                                "space-between",
                                              "margin-top": "20px",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "info",
                                                staticStyle: {
                                                  "align-items": "end",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "source",
                                                    staticStyle: {
                                                      "margin-top": "-5px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "source-img",
                                                      },
                                                      [
                                                        _vm.selectedDoc
                                                          .favicon_url ||
                                                        _vm.selectedDoc
                                                          .favicon_base64
                                                          ? _c("img", {
                                                              staticStyle: {
                                                                "max-width":
                                                                  "40px",
                                                                "max-height":
                                                                  "40px",
                                                                "min-height":
                                                                  "20px",
                                                                "min-width":
                                                                  "20px",
                                                              },
                                                              attrs: {
                                                                src: _vm
                                                                  .selectedDoc
                                                                  .favicon_url
                                                                  ? _vm
                                                                      .selectedDoc
                                                                      .favicon_url
                                                                  : _vm
                                                                      .selectedDoc
                                                                      .favicon_base64,
                                                                alt: "",
                                                              },
                                                              on: {
                                                                error:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm
                                                                      .selectedDoc
                                                                      .url &&
                                                                    _vm.selectedDoc.url.startsWith(
                                                                      "http"
                                                                    )
                                                                      ? (_vm.selectedDoc.favicon_url =
                                                                          "https://www.google.com/s2/favicons?domain=" +
                                                                          _vm
                                                                            .selectedDoc
                                                                            .url)
                                                                      : (_vm.selectedDoc.favicon_url =
                                                                          "/content/images/icon-resources-web.png")
                                                                  },
                                                              },
                                                            })
                                                          : _vm.selectedDoc
                                                              .url &&
                                                            _vm.selectedDoc.url.startsWith(
                                                              "http"
                                                            )
                                                          ? _c("img", {
                                                              attrs: {
                                                                src:
                                                                  "https://www.google.com/s2/favicons?domain=" +
                                                                  _vm
                                                                    .selectedDoc
                                                                    .url,
                                                              },
                                                              on: {
                                                                error:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.selectedDoc.favicon_url =
                                                                      "/content/images/icon-resources-web.png"
                                                                  },
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.selectedDoc.writer ||
                                                    _vm.selectedDoc.url
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "source-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                " +
                                                                _vm._s(
                                                                  _vm.ExtractHostname(
                                                                    _vm
                                                                      .selectedDoc
                                                                      .url,
                                                                    _vm
                                                                      .selectedDoc
                                                                      .writer
                                                                  )
                                                                ) +
                                                                "\n                              "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.selectedDoc.published_at
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "date" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.processDatetime(
                                                              _vm.selectedDoc
                                                                .published_at
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      { staticClass: "date" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "global.timeRecently"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm.isShowOriginLink(
                                                _vm.selectedDoc
                                              )
                                                ? _c(
                                                    "a",
                                                    {
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.viewPost(
                                                            _vm.selectedDoc.url
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "text" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "feed.detail.view-original-text"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("i", {
                                                        staticClass:
                                                          "go-icon-newwindow go-icon-16",
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "section-body" }, [
                                      _vm.isDocumentFile(_vm.selectedDoc.url)
                                        ? _c("div", [
                                            !_vm.isCheckLoading
                                              ? _c(
                                                  "div",
                                                  { staticClass: "loader" },
                                                  [
                                                    _c("div", {
                                                      staticClass: "spinner",
                                                    }),
                                                    _vm._v(" "),
                                                    _c("b-skeleton", {
                                                      attrs: {
                                                        height: "800px",
                                                        width: "100%",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("iframe", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.isCheckLoading,
                                                  expression: "isCheckLoading",
                                                },
                                              ],
                                              ref: "docsEmbed",
                                              attrs: {
                                                onLoad: _vm.onIframeLoaded,
                                                src:
                                                  "https://docs.google.com/viewer?url=" +
                                                  _vm.buildUrl(
                                                    _vm.selectedDoc.url
                                                  ) +
                                                  "&embedded=true",
                                                embedded: "true",
                                                width: "100%",
                                                height: "800px",
                                                frameborder: "1",
                                              },
                                            }),
                                          ])
                                        : _vm.loading
                                        ? _c(
                                            "div",
                                            [
                                              _c("b-skeleton", {
                                                attrs: {
                                                  height: "25px",
                                                  width: "70%",
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("b-skeleton", {
                                                attrs: {
                                                  height: "200px",
                                                  width: "100%",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm.selectedDoc.search_type ===
                                            "USERNOTE" ||
                                          _vm.noNeedToCraw(_vm.selectedDoc)
                                        ? _c("div", [
                                            _c(
                                              "div",
                                              { staticClass: "text-area" },
                                              [
                                                _c("p", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.selectedDoc.content
                                                        ? _vm.selectedDoc
                                                            .content
                                                        : _vm.selectedDoc
                                                            .description
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ])
                                        : _vm.selectedDoc.url &&
                                          _vm.isYoutube(_vm.selectedDoc.url) &&
                                          _vm.selectedDoc.url.includes("watch")
                                        ? _c("div", { staticClass: "img" }, [
                                            _c("iframe", {
                                              staticStyle: {
                                                "min-height": "500px",
                                              },
                                              attrs: {
                                                width: "100%",
                                                height: "100%",
                                                src: _vm.getEmbedLink(
                                                  _vm.selectedDoc.url
                                                ),
                                                title: "YouTube video player",
                                                frameborder: "0",
                                                allow:
                                                  "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                                allowfullscreen: "",
                                              },
                                            }),
                                          ])
                                        : _vm.selectedDoc.html_content &&
                                          _vm.isShowHtmlContent
                                        ? _c("div", {
                                            staticClass: "html-content-area",
                                            attrs: {
                                              id: "html-content-deatail-reference",
                                            },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.selectedDoc.html_content
                                              ),
                                            },
                                          })
                                        : _vm.selectedDoc.content &&
                                          !_vm.isShowHtmlContent
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "html-content-area",
                                              attrs: {
                                                id: "text-content-deatail-reference",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                          " +
                                                  _vm._s(
                                                    _vm.selectedDoc.content
                                                  ) +
                                                  "\n                        "
                                              ),
                                            ]
                                          )
                                        : _c("div", [
                                            _vm.selectedDoc.url &&
                                            !_vm.isShowHtmlContent
                                              ? _c("iframe", {
                                                  ref: "urlEmbed",
                                                  attrs: {
                                                    src: _vm.selectedDoc.url,
                                                    embedded: "true",
                                                    width: "100%",
                                                    height: "800px",
                                                    frameborder: "1",
                                                  },
                                                })
                                              : _vm._e(),
                                          ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }